// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"809a2d09","639":"23072d84"}[chunkId] + ".chunk.js";
};